import React, { useState, useEffect } from "react";
import { SubscriptionService } from "../../services";
import { injectModels } from "../../redux/injectModels";
import { toast } from "react-toastify";
import { AuthService } from "../../services";
import { useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import CustomModal from "../../components/Modal/Modal";
import { Button, Form, Modal } from "react-bootstrap";
import { UserRoleType } from "../../constants/Enum";
import { handleConsoleError } from "../../utils/common-methods";

const SubscriptionList = (props) => {
  const servies = [
    //{ id: 1, title: "Pitch Fee or Turnover Commission drop down tick box." },
    { id: 1, title: "Build, On Event and Break Trader Manager = £450 p/d" },
    { id: 2, title: "Pre Event Trader Curation = £500 p/d" },
    { id: 3, title: "Secret Shoppers = from £500 p/d" },
    {
      id: 4,
      title:
        "EPOS Terminal Hire = from £95 per unit (a min. of two per unit). This is usually billed to the trader",
    },
    { id: 5, title: "Fully Closed As Well As Public Access Event WiFi = £POA" },
    { id: 6, title: "Onsite Build and Live EHO Auditing Team = £POA" },
  ];

  const loginUser = AuthService.getLoginUser();
  const [selectedPlan, setSeletedPlan] = useState("noplan");
  const [error, setError] = useState("");
  const [subscriptionPlans, setSubscriptionPlan] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShow] = useState(false);
  const [showModalSilver, setShowModalSilver] = useState(false);

  const [seletedServices, setSelectedServices] = useState([]);
  const [customPlanId, setCustomPlanId] = useState("");
  const [seletedRT, setSelectedRT] = useState("Pitch Fee");

  const closeModal = () => {
    setModalOpen(false);
    setShowModalSilver(false);
  };

  useEffect(() => {
    if (loginUser && loginUser?.role === UserRoleType.EO) {
      ///getPlan Details
      getData();
      getActivePlanData();
    } else {
      navigate(routes.DEFAULT);
    }
  }, []);

  const getActivePlanData = async () => {
    props.application.setLoading(true);

    try {
      const res = await SubscriptionService.getActiveSubscriptionById(
        loginUser?.id
      );
      if (res?.isSuccess) {
        if (res?.data?.subscriptionPlanName) {
          setSeletedPlan(res?.data?.subscriptionPlanName);
        } else {
          setSeletedPlan("no plan");
        }
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
        //toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      }
    } catch (error) {
      props.application.setLoading(false);
        const message=handleConsoleError(error)
      toast.error(error?.message|| message);
      
      setSeletedPlan("noplan");
    }
  };

  const getData = async () => {
    props.application.setLoading(true);

    try {
      const res = await SubscriptionService.getSubscriptionListActive();
      if (res?.isSuccess && res?.data?.length > 0) {
        setSubscriptionPlan(res?.data);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message= handleConsoleError(error);
          toast.error(error?.message|| message);
    }
  };

  const handleSubmit = async (selectedPlan) => {
    if (selectedPlan === "") {
      setError("Please select Subscription Plan.");
    } else {
      props.application.setLoading(true);

      try {
        const data = {
          subscriptionPlanId: selectedPlan,
          userId: loginUser?.id,
        };
        const res = await SubscriptionService.buySubscriptionPlan(data);
        if (res?.isSuccess) {
          props.application.setLoading(false);
          toast.success(res?.message);
          navigate(routes.ACCOUNT_ACTIVESUBSCRIPTIONP);
        } else {
          props.application.setLoading(false);
         toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        }
      } catch (error) {
        const message=handleConsoleError(error)
        props.application.setLoading(false);
        toast.error(error?.message || message);
      }
    }
  };

  const handleContactUs = async (selectedPlan, planName) => {
    setCustomPlanId(selectedPlan);
    if (isGoldPlan(planName)) {
      setShow(true);
    } else {
      setShowModalSilver(true);
    }
  };

  const handleCustomPlan = async () => {
    try {
      props.application.setLoading(true);
      const data = {
        planId: customPlanId,
        responseJson: JSON.stringify(seletedServices),
      };
      const res = await SubscriptionService.submitSubscriptionEnquiry(data);
      if (res?.isSuccess) {
        // const dataSub = {
        //   subscriptionPlanId: customPlanId,
        //   userId: loginUser?.id,
        // };
        // const res = await SubscriptionService.buySubscriptionPlan(dataSub);
        props.application.setLoading(false);
        toast.success(res?.message);
        navigate(routes.ACCOUNT_ACTIVESUBSCRIPTIONP);
      } else {
        props.application.setLoading(false);
       toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      }
    } catch (error) {
       const message=handleConsoleError(error)
      props.application.setLoading(false);
      toast.error(error?.message || message);
    }
  };

  const handleCustomPlanSilver = async () => {
    try {
      props.application.setLoading(true);
      const service = {
        id: 1,
        title: `${seletedRT} drop down tick box.`,
      };
      const data = {
        planId: customPlanId,
        responseJson: JSON.stringify(service),
      };
      const res = await SubscriptionService.submitSubscriptionEnquiry(data);
      if (res?.isSuccess) {
        // const dataSub = {
        //   subscriptionPlanId: customPlanId,
        //   userId: loginUser?.id,
        // };
        // const res = await SubscriptionService.buySubscriptionPlan(dataSub);
        props.application.setLoading(false);
        toast.success(res?.message);
        navigate(routes.ACCOUNT_ACTIVESUBSCRIPTIONP);
      } else {
        props.application.setLoading(false);
        toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
      }
    } catch (error) {
      const message=handleConsoleError(error)
      props.application.setLoading(false);
      toast.error(error?.message || message);
    }
  };

  const isActivePlan = (planName) => {
    const res = planName?.toLowerCase().includes(selectedPlan?.toLowerCase());
    return res;
  };
  const isGoldPlan = (planName) => {
    const res = planName?.toLowerCase().includes("gold");
    return res;
  };
  const isSilverPlan = (planName) => {
    const res = planName?.toLowerCase().includes("silver");
    return res;
  };
  const isBronzePlan = (planName) => {
    const res = planName?.toLowerCase().includes("bronze");
    return res;
  };

  const planClass = (planName) => {
    const res = planName?.toLowerCase().includes(selectedPlan?.toLowerCase());
    if (res) {
      return "subscription-plan1 active-plan";
    } else {
      return "subscription-plan1";
    }
  };

  const handleClose = () => {
    setShow(false);
    setShowModalSilver(false);
  };

  const handleChange = (e) => {
    setSelectedRT(e.target.value);
  };

  return (
    <React.Fragment>
      <CustomModal isOpen={isModalOpen} onClose={closeModal}>
        <p> This is contact us modal</p>
      </CustomModal>
      <section className="subscription-banner">
        <div className="container">
          <h3>Subscription Plans</h3>
        </div>
      </section>

      <section className="subscription-plan">
        <div className="container">
          <div className="row">
            {subscriptionPlans &&
              subscriptionPlans.length > 0 &&
              subscriptionPlans.map((item, index) => (
                <div className="col-lg-4 col-md-6 col-sm-12 mb-3" key={index}>
                  <div className={planClass(item?.subscriptionPlanName)}>
                    <h3 style={{ gap: "10px" }}>
                      {isGoldPlan(item?.subscriptionPlanName) && (
                        <img
                          // style={{ width: "66px" }}
                          src="/assets/images/gold-nw.png"
                          alt=""
                        />
                      )}
                      {isSilverPlan(item?.subscriptionPlanName) && (
                        <img
                          // style={{ width: "66px" }}
                          src="/assets/images/silver-nw.png"
                          alt=""
                        />
                      )}
                      {isBronzePlan(item?.subscriptionPlanName) && (
                        <img
                          // style={{ width: "66px" }}
                          src="/assets/images/bronze-nw.png"
                          alt=""
                        />
                      )}

                      {item?.subscriptionPlanName}
                    </h3>
                    <h6>
                      {" "}
                      {isGoldPlan(item?.subscriptionPlanName) &&
                        "We have the controls"}
                      {isSilverPlan(item?.subscriptionPlanName) &&
                        "Take me under your wing"}
                      {isBronzePlan(item?.subscriptionPlanName) &&
                        "I'm flying solo"}
                    </h6>
                    <div className="percent-plan">
                      {/* <h4>{item.commission}%</h4> */}

                      {/* {isBronzePlan(item.subscriptionPlanName) && ( */}
                      <h4>FREE*</h4>
                      {/* )} */}
                      <h5>
                        {isBronzePlan(item?.subscriptionPlanName)
                          ? "*only " + item?.commission + "%  buyers fees"
                          : "*from as little as " +
                            item?.commission +
                            "% buyers fees"}
                      </h5>
                    </div>
                    <div className="account-hg1">
                      <p
                        dangerouslySetInnerHTML={{ __html: item?.description }}
                      />
                    </div>

                    {!isActivePlan(item?.subscriptionPlanName) &&
                      (!isBronzePlan(item?.subscriptionPlanName) ? (
                        item?.subscriptionPlanName && (
                          <div className="btn-outernw">
                            <div className="button-select">
                              <a
                                href="#!"
                                onClick={() =>
                                  handleContactUs(
                                    item?.id,
                                    item?.subscriptionPlanName
                                  )
                                }
                              >
                                Contact Us
                              </a>
                            </div>
                          </div>
                        )
                      ) : (
                        <div className="btn-outernw">
                          <div className="button-select">
                            <a href="#!" onClick={() => handleSubmit(item?.id)}>
                              Select
                            </a>
                          </div>
                        </div>
                      ))}
                    {isActivePlan(item?.subscriptionPlanName) && (
                      <div className="btn-outernw">
                        <div className="button-select ">
                          <a
                            href="#!"
                            style={{ pointerEvents: "none" }}
                            className="active-plan-button"
                          >
                            Current Plan
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
      <Modal show={showModal} onHide={handleClose} backdrop="static" centered>
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title>Customize based on your needs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {servies.map((service) => (
              <div key={service?.id} className="mb-3">
                <Form.Check type="checkbox" id={`${service?.id}`}>
                  <Form.Check.Input
                    onChange={(e) => {
                      var services = seletedServices;
                      if (
                        e.target.checked &&
                        !seletedServices.includes(service)
                      ) {
                        services.push(service);
                      } else {
                        services = services.filter(
                          (x) => `${x.id}` !== e.target.id
                        );
                      }
                      setSelectedServices(services);
                    }}
                    type="checkbox"
                    isValid
                  />
                  <Form.Check.Label style={{ color: "gray" }}>
                    <h6>{`${service?.title}`}</h6>
                  </Form.Check.Label>
                </Form.Check>
              </div>
            ))}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="submit"
            variant="primary custom-button-colour"
            onClick={handleCustomPlan}
          >
            {"Submit"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalSilver}
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title>Customize based on your needs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* {servies.map((service) => (
              <div key={service.id} className="mb-3">
                <Form.Check type="checkbox" id={`${service.id}`}>
                  <Form.Check.Input
                    onChange={(e) => {
                      var services = seletedServices;
                      if (
                        e.target.checked &&
                        !seletedServices.includes(service)
                      ) {
                        services.push(service);
                      } else {
                        services = services.filter(
                          (x) => `${x.id}` !== e.target.id
                        );
                      }
                      setSelectedServices(services);
                    }}
                    type="checkbox"
                    isValid
                  />
                  <Form.Check.Label style={{ color: "gray" }}>
                    <h6>{`${service.title}`}</h6>
                  </Form.Check.Label>
                </Form.Check>
              </div>
            ))} */}
            {/* { id: 1, title: "Pitch Fee or Turnover Commission drop down tick box." } */}
            <label>Select Revenue Type</label>
            <select
              name="type"
              id=""
              className="form-control"
              value={seletedRT}
              onChange={handleChange}
            >
              <option value="Pitch Revenue">Pitch Revenue</option>
              <option value="Turnover Commission">Turnover Commission</option>
            </select>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="submit"
            variant="primary custom-button-colour"
            onClick={handleCustomPlanSilver}
          >
            {"Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
export default injectModels(["auth", "application"])(SubscriptionList);
